<template>
  <b-container class="landing-page">
    <Description @upgradeClicked="upgradeClicked" :item="template" v-if="template" cols="12" md="3">
      <template #buttons>
        <b-col sm="12" v-if="user">
          <b-alert variant="success" :show="true" v-if="alreadyOwned" class="mt-2"> {{ $t('templateAlreadyOwned') }}
          </b-alert>
          <template v-else>
            <b-button class="landing-button" variant="success" @click="activationCodeModal = true" block
              v-if="template.activation_code">{{ $t('iHaveActivationCode') }}</b-button>
            <template v-else>
              <b-button class="landing-button" variant="success" @click="checkout()" block v-if="canShowTrial">{{
                $t('startTrial') }}</b-button>
              <b-button class="landing-button" variant="success" @click="checkout()" block v-else>{{ $t('buy') }} {{
                template.priceInCurrency(currency) }} {{ currency }}</b-button>
            </template>

          </template>
        </b-col>
        <b-col sm="12" v-if="!user">
          <b-button class="landing-button" variant="success" @click="activationCodeModal = true" block
            v-if="template.activation_code">{{ $t('iHaveActivationCode') }}</b-button>
          <template v-else>
            <b-button block variant="success" @click="checkout()" v-if="canShowTrial">{{ $t('startTrial') }}</b-button>
            <b-button class="landing-button" variant="success" @click="goToRegister()" block v-else>{{
              $t('registerAndBuy') }} {{ price }} {{ currency }}</b-button>
          </template>
        </b-col>
        <b-col sm="12" v-if="activationCodeModal" class="mt-2">
          <b-input-group class="mb-2">
            <b-form-input v-model="activationCode" :placeholder="`${$t('activationCode')}`"
              @keyup="searchTemplateByActivationCode" />
            <b-input-group-append>
              <b-button :disabled="!validCode" variant="success" @click="checkout()"> <b-spinner
                  v-if="activationCodeSearching" small /> <span v-else>{{ $t('activate') }}</span> </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </template>
    </Description>

    <b-card v-else>
      <b-row>
        <b-col sm="3">
          <b-skeleton width="100%" height="250px" animation="throb" />
        </b-col>
        <b-col>
          <h2><b-skeleton width="200px" height="30px" animation="throb" /></h2>
          <p><b-skeleton animation="throb" /></p>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<style scoped lang="scss">
@import "@/assets/scss/style.scss";

.form-control {
  background: inherit;
  color: inherit;
  border: 1px solid #e4e7ea;
  border-right: 0px;
}

.template-desc {
  box-shadow: rgb(0 0 0 / 25%) 0px 25px 50px -12px;
  border: none;
}

img.landing-image {
  width: 100%;
}

.landing-button {
  margin-top: 20px;
}

.landing-page.container {
  margin-top: 20px;
  margin-bottom: 50px;
}
</style>

<script>
import Template from "@/lib/Template"
import publicHttp from "../../shared/publicHttp"
import Description from "./Description"
import { debounce, toUpper, toLower } from "lodash"

export default {
  name: "LandingPage",
  components: {
    Description
  },
  data: function () {
    return {
      user: null,
      activationCode: null,
      activationCodeModal: false,
      activationTemplate: null,
      activationCodeSearching: false,
      validCode: false,
      showVideo: false,
      template: null
    }
  },

  computed: {
    locale() {
      if (this.$route.query.lang) {
        return this.$route.query.lang
      }

      return this.$store.getters.getLocale
    },

    alreadyOwned() {
      if (this.$store.getters.getSubscriptions) {
        let valid = this.$store.getters.getSubscriptions.find(s => {
          return s.product_id == this.template.product_id
        })

        return this.template.price <= 0 || valid !== undefined
      }

      return false
    },


    currency() {
      let c = this.$route.query.currency || 'usd'
      return toUpper(c)
    },

    canShowTrial() {
      return this.template.trial_period !== null
    },
  },

  methods: {
    checkout() {
      if (this.user) {
        this.$transactionApi.post("/checkout/link", this.template.prepareForCheckoutLink()).then(resp => {
          window.open(resp.data, '_blank')
        })
      } else {
        this.$router.push({ path: "/register?template=" + this.template.template.id + "&activation_code=" + this.activationCode })
      }
    },

    translate(label) {
      try {
        return label.locales[this.locale]
      } catch {
        return false
      }
    },

    goToRegister() {
      this.$router.push({ path: "/register?template=" + this.template.id })
    },

    upgradeClicked({ id }) {
      window.open(`/template/${id}`);
    },

    searchTemplateByActivationCode: debounce(function () {
      this.activationCodeSearching = true
      this.$http.get("/v1/project/template/activationCode/" + this.activationCode).then((resp) => {
        this.validCode = true
      }).catch(err => {

        this.$bvToast.toast(this.$t('invalidActivationCode'), {
          variant: 'danger',
          title: "Error"
        })
      }).finally(() => {
        this.activationCodeSearching = false
      })
    }, 1000)
  },

  mounted: function () {
    let id = this.$route.params.id;

    document.title = "Loading..."

    publicHttp.get("/v1/project/template/" + id).then((resp) => {
      this.template = new Template(
        resp.data,
        this.locale,
        this.activationCode
      )

      document.title = this.translate(this.template.template.label)
    }).catch(err => {
      this.$bvModal.msgBoxOk(err.message)
    })

    publicHttp.get("/v1/user/model").then((resp) => {
      this.user = resp.data
      this.$store.dispatch('fetchSubscriptions')
    })

  }
}
</script>